import Vue from 'vue/dist/vue.esm'

const EventBus = new Vue()
export default EventBus
